export const setSuccessPopUp = (val) => {
  return {
    type: "SET_SUCCESS_POPUP",
    payload: val
  };
};

export const setSuccessMsg = (msg) => {
  return {
    type: "SET_SUCCESS_MESSAGES",
    payload: msg
  };
};
